 <template>
    <v-container fluid>          
        <v-card>
          <v-toolbar>
            <v-icon>dynamic_feed</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;Consulta masiva Siisa</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
              <!-- <v-row dense>
                  
                </v-row>   -->
            <v-row align="center">
              <v-row align="center">
                <v-col >
                  <v-file-input  
                      v-model="archivoFiltroOperaciones"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo Excel"
                      prepend-icon="mdi-paperclip">
                  </v-file-input>
                </v-col>
                <v-col>
                  <v-btn @click="consultaMasiva()">
                    Consultar
                  </v-btn>
                </v-col>
                <v-col cols="4" lg="3">
                  <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                  item-text="nombre" item-value="id" label="Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                </v-col>
                <v-col cols="4" lg="3">
                  <v-autocomplete v-model="filtro.canalVentaId" :items="listCanalesVenta" autocomplete="disabled"
                  item-text="nombre" item-value="id" label="Canal de venta" placeholder="Seleccione uno" :menu-props="{minWidth:'400'}"></v-autocomplete>
                </v-col>
              </v-row>
            </v-row>
            <v-row align="center">
              <v-col cols="4" lg="3">
                <div>
                    Se encontraron {{this.records.length}} registros para consultar.
                </div>
              </v-col>   
            </v-row>  
            <v-row>
              <v-col>
                <v-alert color="info" dark dense>                  
                  <div>
                    Tener en Cuenta. El archivo debe tener formato Excel, con 6 columnas (Columnas/Encabezados): 
                  </div>
                  <div>
                  A - Cuil, 
                  </div>
                  <div>
                  B - Producto,
                  </div>
                  <div> 
                  C - CalificacionPersona (valores posibles: Nuevo/Renovador)
                  </div>
                  <div>
                  D - IngresoMensual
                  </div>
                  <div>
                  E - EntidadFinancieraCodigo (primeros 3 dígitos del CBU)
                  </div>
                  <div>
                  F - Movimientos
                  </div>
                  
                </v-alert>
              </v-col>
            </v-row>
            
            
            <v-flex>
                <v-card >
                  <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
                    <v-icon>list</v-icon>
                    <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-data-table 
                    loading-text="Buscando registros"
                    dense
                    :headers="headers"
                    :items="this.listTable"
                    :rows-per-page="pagination.itemsPerPage"
                    :options.sync ="pagination"
                    v-model="selectedRows"
                    :loading="loading"  
                    class="elevation-1"
                    :footer-props="footer"
                    item-key="id"
                  >

                  <template v-slot:item="{ item }">
                       <tr>
                        <td class="text-xs-left caption">{{ item.entity.motorApellido}}</td>
                        <td class="text-xs-left caption">{{ item.entity.motorNombre}}</td>
                        <td class="text-xs-left caption">{{ item.entity.motorCuil }}</td>
                        <td class="text-xs-left caption">{{ item.entity.resultado }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card >
            </v-flex>
            <v-divider></v-divider>

            <v-row align="center">
              <v-col cols="4" lg="3">
                <div>
                    Registros que dieron error:
                    <ul>
                      <li v-for="item in this.listTableError" :key="item">
                        {{ item }}
                      </li>
                    </ul>
                </div>
              </v-col>   
            </v-row>  

            <v-row v-if="this.btnDescargar">
              <v-col cols="2">
                  <v-btn @click="procesarLista()"  color="info">
                    Descargar listado
                  </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="this.btnDescargar">
              <v-col cols="2">
                <v-text-field v-model="filtro.separador" label="Separador en archivo"></v-text-field>
              </v-col>                       
            </v-row>  
          </v-card-text>

          <v-card-actions>

          </v-card-actions>
        </v-card >

        <template v-if="$store.state.debugModeOn">
          Debug Info: <p></p>
          
          Model: {{filtro}}  <p></p>                            
        </template>
    </v-container>
      
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {

  data() {
    return {
      loading: false,
      pagination: { // definición de paginación
        sortDesc:[true],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5
      },
      footer:{        
        showFirstLastPage: true,
        itemsPerPageOptions:[5,10,20, 50]
      },
      totalItems: 0, // va afuera de pagination 
      headers: [ // definición de columnas
        { text: 'Apellido', value: 'motorApellido', width:80, sortable:false },
        { text: 'Nombre', value: 'motorNombre', width:80, sortable:false },
        { text: 'Cuil', value: 'motorCuil'},
        { text: 'Respuesta', value: 'resultado'},
      ],
      filtro:{empresaId:0,canalVentaId:0, separador: ';'},
      records: [], // registros
      listTable: [], //registros tabla
      listTableError: [], //registros que dieron error
      selectedRows: [],
      agruparPorSucursal: true,
      archivoFiltroOperaciones:[],
      listEmpresas: [],
      listCanalesVenta: [],
      btnDescargar: false
    };
  },
  async created() {   
      this.loadEmpresas();
       this.loadCanalesVenta();
  },  
  watch: {    
    //  'filtro.empresaId': function(){        
    //     this.loadCanalesVenta();
  },
  computed: {
    ...mapGetters(['getActionFromLink','user']),
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
  },
  methods: {
    ...mapMutations(["setActiveTask", "setActiveSubTask", "alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),

    async loadEmpresas(){
        this.loading = true;
        try{
            var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

            this.listEmpresas = result.list;

            this.loadCanalesVenta();
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadCanalesVenta(){
      this.loading = true;
      try{
        var result = await http.get('canalesventa/habilitadosparausuario?usuarioId='+ this.user.id);

        this.listCanalesVenta = result.list.filter(i=>i.empresaId == this.filtro.empresaId || this.filtro.empresaId == 0);
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async consultaMasiva(){

      if(!this.archivoFiltroOperaciones) return;

      if(!this.archivoFiltroOperaciones.name.includes('.xls'))
      {
        this.archivoFiltroOperaciones = [];
        this.alertWarning('Debe elegir un archivo Excel.');
        return;
      }

      this.loading = true;
      let request = new FormData();  

      let canalVentaId =  this.filtro.canalVentaId;



      request.append('archivo',this.archivoFiltroOperaciones);
      request.append('canalVentaId', canalVentaId);

      try{

        var result = await http.post('creditos/consultamasiva', request);
        this.records = result;

        console.log(result);  
        console.log(result.length);

        this.ingresarConsultaCredito();

      } catch (error) {
          // Error
          this.alertError(error)
      }
      this.loading = false;

    },
    async ingresarConsultaCredito(){
      
      this.loading = true;

      this.btnDescargar = true;  
        for(let i = 0; this.records.length;i++){      

              var parametros = {
                canalVentaId: this.records[i].canalVentaId,
                productoId: this.records[i].productoId,
                calificacionPersonaId: this.records[i].calificacionPersonaId,
                cuil: this.records[i].cuil,
                nombre: this.records[i].nombre,
                apellido: this.records[i].apellido,
                personaId: this.records[i].personaId,
                ingresoMensual: this.records[i].ingresoMensual,
                movimientos: this.records[i].movimientos,
                entidadFinancieraId: this.records[i].entidadFinancieraId,
                esMasiva: this.records[i].esMasiva
              } 

                try {

                    var result = await http.post('creditos/crearconsulta' , JSON.stringify( {solicitud:  parametros} ))

                    this.listTable.push(result);
                    
                } catch (error) {
                  // Error
                  this.alertError(error)
                    this.listTableError.push(parametros.cuil);
                }
        }
    },
    async procesarLista(){

        try {
            this.loading = true;

            console.log(this.listTable);

            var parametros = [];

            for(let i = 0; i < this.listTable.length; i++){

              var data = {
                nombre: this.listTable[i].entity.motorApellido + " " +this.listTable[i].entity.motorNombre,
                cuil: this.listTable[i].entity.motorCuil,
                resultado: this.listTable[i].entity.resultado
              }

              parametros.push(data);

            }

            console.log(parametros);
            console.log(this.filtro.separador);

            await http.post('filegeneration/consultasmasivas', JSON.stringify( 
              {
                listaData: parametros,
                separador: this.filtro.separador
              } 
            ) )
                .then(resp => {
                    console.log(resp);

                    if(resp.error ){
                        this.alertError(resp.error);
                    }
                    else{
                        this.alertSuccess('Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo...');
                        
                        this.loading = true;
                        this.downloadFile(resp, 'ConsultasMasivas.csv');
                        this.loading = false;
                    }

                })
                .catch((e) => {
                    this.alertError(e)
                });
            
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async downloadFile(file, renameTo){
        //convierto el string del path a base64 para poder mandarlo
        let base64String = '';
        base64String = btoa(file.fullPath);
        
        http.get('filemanagement/getfilebypath/'+base64String)
        .then(resp => {
            let dataType = '';
            switch(resp.extension)
            {
                case '.doc':
                case '.docx':
                case '.DOC':
                case '.DOCX':
                    dataType = 'data:application/vnd.ms-word';
                    break;
                case '.pdf':
                case '.PDF':
                    dataType = 'data:application/pdf'
            }
            
            //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
            var arrayBuffer = this.base64ToArrayBuffer(resp.file);
            this.saveByteArray(renameTo, arrayBuffer,dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], {type: dataType});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();      
    },
  }
}
</script>


